import client from "./client";

export const settlementCandidates = async () =>
  (await client.get("/settlements/candidates")).data;
export const settlementPreview = async (userId, lastWorkingDay) =>
  (await client.get(`/settlements/preview/${userId}`, { params: { last_working_day: lastWorkingDay } })).data;
export const listSettlements = async () => (await client.get("/settlements")).data;
export const createSettlement = async (body) => (await client.post("/settlements", body)).data;
